const UILabelConsts = {
    CLOSE_BUTTON:'Fechar',
}

export default UILabelConsts;